import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAs7q6lca8jc4yD-M48CiLZaqFAaNbU5qE",
  authDomain: "khutbah-translation.firebaseapp.com",
  projectId: "khutbah-translation",
  storageBucket: "khutbah-translation.firebasestorage.app",
  messagingSenderId: "1054422851322",
  appId: "1:1054422851322:web:5b5ef5f9b36498ae6cf343",
  measurementId: "G-KCLRCRV905",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
